// TODO lägg till variabler för typsnitt och färger genom hela projektet

import styled, { createGlobalStyle } from 'styled-components'

/* MuiStyles should only be used for Mui component customization
in specific cases where muiTheme can not be used */
const MuiStyles = `
  .MuiSwitch-switchBase.Mui-checked {
    transform: translateX(30px);
  }
`

// e.g. reset CSS from Scensum
export const globalStyles = createGlobalStyle`
  html {
    font-size: unset; // reset bootstrap CSS ('10px')
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: auto !important;
  }

  body {
    line-height: normal !important;
    letter-spacing: normal !important;
  }

  #mok-context-spa,
  .ReactModalPortal {
     ${MuiStyles}

    /* *
    https://gomakethings.com/hidden-content-for-better-a11y/#hiding-the-link
    * Visually hide an element, but leave it available for screen readers
    */
    .screen-reader {
      border: 0;
      clip: rect(0 0 0 0);
      height: 1px;
      margin: -1px;
      overflow: hidden;
      padding: 0;
      position: absolute;
      white-space: nowrap;
      width: 1px;
    }
    /**
    https://gomakethings.com/hidden-content-for-better-a11y/#hiding-the-link
    * Extends the .screen-reader class to allow the element to be focusable when navigated to via the keyboard
    */
    .screen-reader-focusable:active,
    .screen-reader-focusable:focus {
      clip: auto;
      height: auto;
      margin: 0;
      overflow: visible;
      position: static;
      white-space: normal;
      width: auto;
    }

    label {
      float: none;
    }

    label input[type=checkbox]+span {
      background-image: unset;
      background-repeat: unset;
      background-position: unset;
      padding-left: unset;
      min-height: unset;
      display: unset;
    }

    ul:not(.react-tabs__tab-list) {
      margin-left: initial;
      margin-bottom: initial;
    }

    .glyphicon {
      margin-right: initial;
      margin-left: initial;
      color: initial;
    }


    .price {
      // TODO any
      font-family: ${(props: any) => `${props.theme.typography.fontFamily}`} !important;
      font-weight: 500 !important;
    }

    .button-primary,
    .button-primary-arrow,
    .button-primary-large,
    .button-secondary,
    .button-secondary-large-arrow {
      margin: 15px 0 15px;
    }
  }

  .MuiBackdrop-root {
    z-index: 0 !important;
  }
`

export const App = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: fixed;
  background-color: #f9f9f9;
`

export const ProductPageApp = styled.div`
  display: flex;
  flex-direction: column;

  .button-continue-to-configurator {
    text-align: center;
    margin-top: 0 !important;

    @media (min-width: 1200px) {
      width: 70%;
      min-width: 475px;
      align-self: flex-end;
    }
  }
`
